/**
 * MiniMax Music —— capability 元数据（与行为字段分离，便于总览页 import.meta.glob 拿展示信息）。
 */
export default {
  id: 'minimax-music',
  nodeType: 'sound',
  label: 'MiniMax Music',
  description: 'MiniMax 文生音乐, 自然语言描述风格、可选附歌词生成完整曲目 (v2.6 / v2.5).',
}
